<template>
  <el-dialog
    top="10vh"
    class="edit-dialog"
    title="用户详情"
    :visible.sync="dialogVisible"
    :before-close="notBtn"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="800px"
  >
    <el-form ref="form" :model="form" size="small" label-width="140px">
      <el-col :span="12">
        <el-form-item label="用户名：">{{ form.account | formatStr }}</el-form-item>
        <el-form-item label="注册时间：">{{ form.createTime | formatStr }}</el-form-item>
        <el-form-item label="最近登录时间：">{{ form.lastLoginTime | formatStr }}</el-form-item>
        <el-form-item label="最后登录手机系统：">{{ form.mobileType | formatStr }}</el-form-item>
        <el-form-item label="APP版本：">{{ form.appVersion | formatStr }}</el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="昵称：">{{ form.nickName | formatStr }}</el-form-item>
        <el-form-item label="性别：">{{ form.sex | formatStr }}</el-form-item>
        <el-form-item label="姓名：">{{ form.name | formatStr }}</el-form-item>
        <el-form-item label="年龄：">{{ form.age | formatStr }}</el-form-item>
      </el-col>
    </el-form>
    <CommonTable
      ref="table"
      :data="tableData"
      :total="total"
      :needIndex="true"
      @change="handleTableChange"
      :table-json="tablejson"
    >
    </CommonTable>
  </el-dialog>
</template>

<script>
import tablejson from './Model/Tablejson.Detail'
import formTableMixin from '@younuo/mixins/formTableMixin'
import { format } from '@younuo/utils/utils'
export default {
  name: 'Detail',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object
    }
  },
  mixins: [formTableMixin],
  data() {
    return {
      dialogVisible: this.visible,
      form: {},
      tablejson,
      queryApi: this.$api.wine.app_user_device_list
    }
  },
  mounted() {
    if (this.row.id) {
      this.queryDetail(this.row.id)
      this.formSearch()
    }
  },
  filters: {
    formatStr(str) {
      return format(str)
    }
  },
  methods: {
    formSearch(data) {
      let params = { ...data }
      params.userId = this.row.id
      this.search(params, null, this.queryApi)
    },
    queryDetail(id) {
      let params = {
        id: id
      }
      this.$ajax.get(this.$api.wine.app_user_detail, params).then((res) => {
        this.form = res.data
      })
    },
    notBtn() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="less" scoped></style>
